import { Component } from '@angular/core';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div  *ngIf="field.fieldArray.templateOptions.label"><strong>{{ field.fieldArray.templateOptions.label }}</strong></div>
    <div *ngFor="let f of field.fieldGroup; let i = index">
      <div *ngIf="field.fieldArray.templateOptions.indexText" class="mt-2" style="float: left;border: solid 1px blue;padding: 2px 4px;color: blue;font-weight: bold;">
        <span>{{field.fieldArray.templateOptions.indexText}} {{i+1}}</span>
        </div>
      <formly-group
        [model]="model"
        [field]="f"
        [options]="options"
        [form]="formControl"
      >
        <div class="col-sm-1 mt-1">
          <button class="btn btn-danger" type="button" (click)="remove(i)">
            -
          </button>
        </div>
      </formly-group>
    </div>
    <div style="margin:5px 0;">
      <button class="btn btn-primary" type="button" (click)="add()">
        + {{ field.fieldArray.templateOptions.btnText }}
      </button>
    </div>
  `
})
export class RepeatTypeComponent extends FieldArrayType {
  constructor(builder: FormlyFormBuilder) {
    super(builder);
  }
}